import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SfDataService } from '../services/sf-data.service';

export function taxIdUniqueValidator(sfDataService: SfDataService): AsyncValidatorFn {
  return (ctrl: AbstractControl): Observable<ValidationErrors | null> => {
    const value = (ctrl.value as string) ?? '';
    if (value.length < 3) return of(null);

    return timer(600).pipe(
      switchMap(() =>
        sfDataService.checkTaxIdExists(value).pipe(
          map(res => (res.exists ? { taxIdExists: true } : null)),
          catchError(() => of(null))
        )
      )
    );
  };
}
